<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-form-group [controls]="controls.contractType">
      <onyx-dropdown
        [formControl]="controls.contractType"
        label="labels.contractType"
        [options]="contractTypes$ | async"
        [showErrors]="false"
        [size]="32"
      ></onyx-dropdown>

      <onyx-suggestions
        [control]="controls.contractType"
        [suggestions]="CONTRACT_TYPE_SUGGESTIONS"
      ></onyx-suggestions>
    </onyx-form-group>

    @if (contractType()) {
      <onyx-dropdown
        [formControl]="controls.settlementMethod"
        label="labels.driverSettlementMethod"
        [options]="settlementMethods$ | async"
        [size]="32"
      ></onyx-dropdown>

      @switch (settlementMethod()) {
        @case (DriverSettlementMethod.DAILY_RATE) {
          <ng-container
            *ngTemplateOutlet="
              rateAmountTemplate;
              context: { name: 'dailyRate' }
            "
          ></ng-container>
        }
        @case (DriverSettlementMethod.MILEAGE_RATE) {
          <ng-container
            *ngTemplateOutlet="
              rateAmountTemplate;
              context: { name: 'mileageRate' }
            "
          ></ng-container>
        }
        @case (DriverSettlementMethod.BASE_PLUS_PERCENTAGE) {
          <div class="base-rate-plus-percentage">
            <ng-container
              *ngTemplateOutlet="
                rateAmountTemplate;
                context: { name: 'baseRate' }
              "
            ></ng-container>

            <onyx-text-field
              [formControl]="controls.freightPercentage"
              label="labels.freightPercentage"
              [decimalPlaces]="1"
              unit="%"
              [size]="32"
            ></onyx-text-field>
          </div>
        }
        @case (DriverSettlementMethod.ROUND_TRIP_RATE) {
          <ng-container
            *ngTemplateOutlet="
              rateAmountTemplate;
              context: { name: 'roundTripRate' }
            "
          ></ng-container>
        }
      }

      <onyx-datepicker
        [formControl]="controls.contractTerm"
        label="labels.contractFrom"
        labelTo="labels.contractTo"
        [showDateRange]="true"
        [showIndefinite]="true"
        [size]="32"
      ></onyx-datepicker>

      <onyx-upload
        [formControl]="controls.scans"
        label="labels.contractScan"
        [size]="32"
        [limit]="2"
      ></onyx-upload>
    }

    @if (contractType() === ContractType.B2B) {
      <onyx-text-field
        class="nip-number"
        [formControl]="controls.nipNumber"
        label="labels.vatId"
        [size]="32"
      ></onyx-text-field>

      <onyx-text-field
        class="company-name"
        [formControl]="controls.companyName"
        label="labels.company"
        [placeholder]="`${I18N}.companyAutocomplete`"
        [size]="32"
      ></onyx-text-field>
    }
  </form>
</onyx-section>

<ng-template let-name="name" #rateAmountTemplate>
  @let formGroup = form().get(name)!;
  <onyx-form-group
    [formGroup]="$any(formGroup)"
    [label]="`labels.${name}`"
    [controls]="[formGroup.get('value')!, formGroup.get('currency')!]"
    (labelClick)="rateAmountValueControlElement.focus()"
  >
    @let controls = $any(formGroup).controls;
    <onyx-text-field
      [formControl]="controls.value"
      [decimalPlaces]="2"
      [showErrors]="false"
      #rateAmountValueControlElement
      [size]="32"
    ></onyx-text-field>

    <onyx-dropdown
      [formControl]="controls.currency"
      [options]="currencies$ | async"
      [optional]="false"
      width="84px"
      [showErrors]="false"
      [size]="32"
    ></onyx-dropdown>
  </onyx-form-group>
</ng-template>
